export default "__VITE_ASSET__DfO5SHLh__"